const permissionTypes = ['can_add', 'can_change', 'can_delete', 'can_view']

export default permissionTypes
